import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import { TablePagination } from '@material-ui/core';
import ToggleBtn from 'ui/components/toggle-button';
import Progress from '../ui/react-ui/progress.jsx';
import Tabs from '../ui/react-ui/tabs';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import InterfaceEdit from './interface-edit';
import ServiceMonitor from './service-monitor';
import InterfaceRecordSearch from './interface-record-search';
import DataProcessorRecordSearch from './data-processor-record-search';
import DataProvideRecordSearch from './data-provide-record-search'; // api

import { getDataInterfaceList, editDataInterfaceAPI, getDataProcessorList, getDataProvideList } from '../../api/interfaceAPI'; // import { getSystemDataSource, getSystemDataProcessing, getSystemTrafficModelTrainer, getSystemTrafficModelPrediction } from '../../api/systemHealthCheckAPI'
// redux

import { setDataProvideData, setInterfaceSort, setInterfaceData, setDataHandleSort, setDataHandleData, setDialogInfo, clearDialogInfo, reset } from '../../redux/setting-service';
var t = i18n.getFixedT(null, 'setting-service');
var Service = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$service = _useSelector.service,
      dataProvideData = _useSelector$service.dataProvideData,
      interfaceSort = _useSelector$service.interfaceSort,
      interfaceData = _useSelector$service.interfaceData,
      dataHandleSort = _useSelector$service.dataHandleSort,
      dataHandleData = _useSelector$service.dataHandleData,
      dialogInfo = _useSelector$service.dialogInfo;

  var dispatch = useDispatch(); // page table size

  var id = props.id;

  var _useState = useState('interface'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(''),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      data = _useState12[0],
      setData = _useState12[1];

  var isMounted = useRef(false);

  var _isResetUseState = useRef(false);

  var _tableData = useRef([]);

  var _tableSort = useRef(null);

  var tabsMenu = [{
    key: 'interface',
    title: t('lbl-interface')
  }, {
    key: 'dataHandle',
    title: t('lbl-data-handle')
  }, {
    key: 'dataProvide',
    title: t('lbl-data-provide')
  }, {
    key: 'service',
    title: t('lbl-service-monitor')
  }];

  var handleCloseDialog = function handleCloseDialog() {
    if (dialogInfo.mode === 'edit') fetchData();
    dispatch(clearDialogInfo());
  };

  var handleOpenDialog = function handleOpenDialog(mode, data) {
    dispatch(setDialogInfo({
      mode: mode,
      data: data
    }));
  };

  var handleToogleStatus = function handleToogleStatus(data, val) {
    var newData = _.cloneDeep(data);

    _.set(newData, 'schedule.enabled', val);

    Progress.startSpin();
    editDataInterfaceAPI(contextRoot, true, newData).then(function (result) {
      fetchData();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
  };

  var handleSort = function handleSort(sort) {
    if (currentTab === 'interface') return dispatch(setInterfaceSort(sort));
    if (currentTab === 'dataHandle') return dispatch(setDataHandleSort(sort));
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (currentTab === 'service') return;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;
    var offset = (Number(_currentPage + 1) - 1) * rowsPerPage;

    switch (currentTab) {
      case 'interface':
        getDataInterfaceList(contextRoot, false, _keyword, interfaceSort, offset, _rowsPerPage).then(function (result) {
          var newData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setInterfaceData(newData));
          setTotalCount(result.totalElements);
          isMounted.current = true;
        });
        break;

      case 'dataHandle':
        getDataProcessorList(contextRoot, false, _keyword, dataHandleSort, offset, _rowsPerPage).then(function (result) {
          var newData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setDataHandleData(newData));
          setTotalCount(result.totalElements);
          isMounted.current = true;
        });
        break;

      case 'dataProvide':
        getDataProvideList(contextRoot, false).then(function (result) {
          var newData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setDataProvideData(newData));
          isMounted.current = true;
        });
    }
  };

  useEffect(function () {
    if (!isMounted.current) return;
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [JSON.stringify(dataHandleSort), JSON.stringify(interfaceSort), keyword, currentPage, rowsPerPage]);
  useEffect(function () {
    if (!isMounted.current) return;
    if (currentPage !== 0 || keyword !== '' || rowsPerPage !== 10) _isResetUseState.current = true;
    setCurrentPage(0);
    setKeyword('');
    setRowsPerPage(10);
    fetchData(true);
  }, [currentTab]);
  useEffect(function () {
    if (!isMounted.current) {
      fetchData(true);
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  var fields = {};

  switch (currentTab) {
    case 'interface':
      _tableData.current = interfaceData;
      _tableSort.current = interfaceSort;

      _.set(fields, 'sequence', {
        label: t('lbl-sequence')
      });

      _.set(fields, 'name', {
        label: t('lbl-interface-info-id'),
        sortable: true
      });

      _.set(fields, 'system', {
        label: t('lbl-source-system'),
        sortable: true
      });

      _.set(fields, 'description', {
        label: t('lbl-description')
      });

      _.set(fields, 'interfacingAt', {
        label: t('lbl-interface-date'),
        sortable: true,
        formatter: function formatter(val, row) {
          return moment(val).format('YYYY-MM-DD HH:mm:ss');
        }
      });

      _.set(fields, 'sourceStatus', {
        label: t('lbl-status'),
        sortable: true,
        formatter: function formatter(val, row) {
          return t("lbl-".concat(val.toUpperCase()));
        }
      });

      _.set(fields, 'enabled', {
        label: t('lbl-enable-status'),
        formatter: function formatter(val, row) {
          if (row.sourceType === 'FlatFile') return null;
          return /*#__PURE__*/React.createElement(ToggleBtn, {
            onChange: function onChange(val) {
              return handleToogleStatus(row, val);
            },
            on: row.schedule ? row.schedule.enabled : false
          });
        }
      });

      _.set(fields, 'interfaceRecord', {
        label: t('lbl-interface-record'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return handleOpenDialog('search', row);
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fas fa-search"
          })));
        }
      });

      _.set(fields, 'more', {
        label: t('lbl-more'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return handleOpenDialog('edit', row);
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fa fa-pencil-alt fa-list-alt"
          })));
        }
      });

      break;

    case 'dataHandle':
      _tableData.current = dataHandleData;
      _tableSort.current = dataHandleSort;

      _.set(fields, 'sequence', {
        label: t('lbl-sequence')
      });

      _.set(fields, 'target', {
        label: t('lbl-data-target'),
        sortable: true
      });

      _.set(fields, 'targetDescription', {
        label: t('lbl-data-target-description'),
        sortable: true
      });

      _.set(fields, 'source', {
        label: t('lbl-source-data'),
        sortable: true
      });

      _.set(fields, 'progress', {
        label: t('lbl-progress'),
        sortable: true
      });

      _.set(fields, 'lastTime', {
        label: t('lbl-lastTime'),
        sortable: true
      });

      _.set(fields, 'lastResult', {
        label: t('lbl-lastResult'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val ? t("lbl-lastResult-".concat(val.toUpperCase())) : '';
        }
      });

      _.set(fields, 'dataRecord', {
        label: t('lbl-data-process-record'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return handleOpenDialog('search', row);
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fas fa-search"
          })));
        }
      });

      break;

    case 'dataProvide':
      _tableData.current = dataProvideData;

      _.set(fields, 'sequence', {
        label: t('lbl-sequence')
      });

      _.set(fields, 'moduleName', {
        label: t('lbl-data-provide-type')
      });

      _.set(fields, 'dataTime', {
        label: t('lbl-interface-date')
      });

      _.set(fields, 'actionResult', {
        label: t('lbl-interface-result'),
        formatter: function formatter(val, row) {
          if (parseInt(val) === -1) return '';
          return parseInt(val) === 0 ? t('lbl-SUCCESS') : t('lbl-FAILED');
        }
      });

      _.set(fields, 'interfaceRecord', {
        label: t('lbl-interface-record'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return handleOpenDialog('search', row);
            }
          }, /*#__PURE__*/React.createElement("i", {
            className: "fas fa-search"
          })));
        }
      });

      break;

    default:
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, (currentTab === 'interface' || currentTab === 'dataHandle') && /*#__PURE__*/React.createElement("div", {
    className: "service-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(searchText) {
      if (_.isEmpty(keyword) && _.isEmpty(searchText) && currentPage !== 0) return setCurrentPage(0);
      if (_.isEmpty(keyword)) fetchData();
      setKeyword(searchText);
    },
    value: keyword
  })), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-service-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, currentTab === 'interface' || currentTab === 'dataHandle' || currentTab === 'dataProvide' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: _tableData.current,
    sort: _tableSort.current,
    onSort: handleSort
  })), currentTab !== 'dataProvide' && /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })) : /*#__PURE__*/React.createElement(ServiceMonitor, null)), dialogInfo.mode === 'edit' && /*#__PURE__*/React.createElement(InterfaceEdit, {
    onClose: handleCloseDialog
  }), dialogInfo.mode === 'search' && currentTab === 'interface' && /*#__PURE__*/React.createElement(InterfaceRecordSearch, {
    onClose: handleCloseDialog
  }), dialogInfo.mode === 'search' && currentTab === 'dataHandle' && /*#__PURE__*/React.createElement(DataProcessorRecordSearch, {
    onClose: handleCloseDialog
  }), dialogInfo.mode === 'search' && currentTab === 'dataProvide' && /*#__PURE__*/React.createElement(DataProvideRecordSearch, {
    onClose: handleCloseDialog
  }));
});
Service.defaultProps = {
  id: 'g-service'
};
Service.PropTypes = {
  id: PropTypes.string
};
export default Service;